<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">课程管理</Breadcrumb-item>
        <Breadcrumb-item>课后视频</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div style="margin-top: 20px" @keyup.enter="search">
    <Form ref="previewForm" class="form"
          :model="queryParam" :label-width="80" label-position="left">
      <Row :gutter="32">
        <Col :span="6">
        <Form-item label="教材版本">
          <Select v-model.number="queryParam.materialVersion" clearable @on-change="onVersionChange">
            <Option v-for="item in $constant.materialVersions" :key="item.code" :value="item.code">{{item.text}}</Option>
          </Select>
        </Form-item>
        </Col>
        <Col :span="6">
        <Form-item label="课程等级">
          <Select v-model.number="queryParam.levelId" clearable filterable @on-change="onLevelChange">
            <Option v-for="item in levels" :key="item.id" :value="item.id">{{item.title}}</Option>
          </Select>
        </Form-item>
        </Col>
        <Col :span="6">
          <Form-item label="标题">
            <Input
              placeholder="支持模糊搜索"
              name="lessonTitle"
              v-model="queryParam.lessonTitle"
            ></Input>
          </Form-item>
        </Col>
        <Col :span="2">
          <Button type="primary" @click="search">搜索</Button>
        </Col>
      </Row>
    </Form>
<!--      <Button type="primary" @click="addLessonVideo">添加</Button>-->
    </div>
    <List style="margin-top: 10px" ref="dataList" :tableColumns="title" :reload="reload" listUrl="/bookLessonVideo/listByPage"
          :params="queryParam"></List>
    <LessonVideoInsertModal :value="showInsertModal" :successCallback="search" @on-close="closeModal"></LessonVideoInsertModal>
    <LessonVideoUpdateModal :value="showUpdateModal" :successCallback="search" :id="id" @on-close="closeModal"></LessonVideoUpdateModal>
  </div>
</template>
<script>
  import LessonVideoInsertModal from './LessonVideoInsertModal'
  import LessonVideoUpdateModal from './LessonVideoUpdateModal'
  export default {
    components: {
      LessonVideoUpdateModal,
      LessonVideoInsertModal
    },
    data () {
      let $constant = this.$constant
      return {
        searchLoading: false,
        reload: 0,
        onLoading: false,
        queryParam: {
          materialVersion: '',
          levelId: '',
          lessonId: '',
          lessonTitle: '',
        },
        levels: [],
        lessons: [],
        showInsertModal: false,
        showUpdateModal: false,
        title: [
          {
            title: 'ID',
            key: 'lessonId',
            width: 80,
            align: 'center',
          },
          {
            title: '教材版本',
            key: 'materialVersion',
            width: 100,
            align: 'center',
            render: (h, params) => {
              let version = params.row.materialVersion
              let materialVersion = $constant.getEnum($constant.materialVersions, version)
              return h('span', materialVersion && materialVersion.text)
            }
          },
          {
            title: '课程等级',
            key: 'levelTitle',
            width: 150,
            align: 'center',
          },
          {
            title: '课程标题',
            key: 'lessonTitle',
            width: 170,
            align: 'center',
          },
          {
            title: '视频地址',
            // key: 'videoUrl',
            width: 200,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              if (row.videoUrl) {
                return h('a', {domProps: {title: '点击预览'}, on: {click: () => this.showIndex(row.videoUrl, 1)}}, row.videoUrl)
              } else {
                return h('span')
              }
            }
          },
          {
            title: '无声视频',
            // key: 'videoUrl',
            width: 200,
            align: 'center',
            render: (h, params) => {
              let row = params.row
              let noVoide = params.row.videoUrl
              if (row.videoUrl) {
                noVoide = noVoide.replace(/\.mp4/g, '_no_voice.mp4')
                return h('a', {domProps: {title: '点击预览'}, on: {click: () => this.showIndex(noVoide, 0)}}, noVoide)
              } else {
                return h('span')
              }
            }
          },
          {
            title: '每课一曲',
            align: 'center',
            // key: 'musicUrl',
            width: 200,
            render: (h, params) => {
              let row = params.row
              if (row.musicUrl) {
                return h('a', {domProps: {title: '点击预览'}, on: {click: () => this.showIndex(row.musicUrl)}}, row.musicUrl)
              } else {
                return h('span')
              }
            }
          },
          {
            title: '创建时间',
            key: 'gmtCreate',
            width: 175,
            align: 'center',
          },
          {
            title: '创建人',
            key: 'creatorName',
            width: 150,
            align: 'center',
          },
          {
            title: '更新时间',
            key: 'gmtModified',
            align: 'center',
            width: 175,
            align: 'center',
          },
          {
            title: '最新操作人',
            key: 'modifierName',
            width: 150,
            align: 'center',
          },
          {
            title: '操作',
            width: 120,
            align: 'center',
            fixed: 'right',
            render: (h, params) => {
              let row = params.row
              return h('div', [
                h('a', { on: { click: () => this.editLesson(row.lessonId) } }, '编辑'),
                h('a', { style: { marginLeft: '10px' }, on: { click: () => this.generateNoVoiceVideo(row.videoUrl) } }, '生成无声视频')
              ])
            }
          }
        ],
        id: null
      }
    },
    mounted: function () {
      let self = this
      let query = self.$route.query
      if (query) {
        if (query.materialVersion) {
          self.queryParam.materialVersion = query.materialVersion
        }
        if (query.levelId) {
          self.queryParam.levelId = parseInt(query.levelId)
        }
        if (query.lessonId) {
          self.queryParam.lessonId = parseInt(query.lessonId)
        }
      }
    },
    created: function () {
    },
    methods: {
      generateNoVoiceVideo (videoUrl) {
        // 这里添加生成无声视频的逻辑
        // 示例：调用 API 生成无声视频
        this.$http.get('/video/execute?old=y&path=' + videoUrl).then(res => {
          if (res.data) {
            this.$Message.success(res.data)
          } else {
            this.$Message.error('生成无声视频失败')
          }
        }).catch(error => {
          this.$Message.error('生成无声视频失败: ' + error.message)
        })
      },
      showIndex (videoUrl, type) {
        // 无声
        if (type === 0) {
          if (videoUrl) {
            window.open('http://oss.kouyujie.cn/' + videoUrl)
          }
        } else {
          if (videoUrl) {
            window.open('http://medias.kouyujie.cn/' + videoUrl + '?' + Date.parse(new Date()))
          }
        }
      },
      addLessonVideo () {
        this.showInsertModal = true
      },
      onVersionChange (val) {
        let self = this
        if (val) {
          self.levelId = val
          self.$http.get('/bookMaterialLevel/listByCondition?materialVersion=' + val).then(function (res) {
            if (res.data) {
              self.levels = res.data
            }
          })
        }
        this.search()
      },
      search () {
        this.reload = new Date().getTime()
      },
      onLessonChange (val) {
        this.queryParam.lessonId = val
        this.search()
      },
      onLevelChange (val) {
        let self = this
        if (val) {
          self.levelId = val
          self.$http.get('/bookMaterialLessons/listByCondition?levelId=' + val).then(function (res) {
            if (res.data) {
              self.lessons = res.data
            }
          })
        }
        this.search()
      },
      editLesson (id) {
        this.showUpdateModal = true
        this.id = id
      },
      closeModal () {
        this.showUpdateModal = false
        this.showInsertModal = false
        this.id = null
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LessonVideoList.vue?225fa610